module.exports = __webpack_public_path__ + "media/images/iphone-12-dashboard-active-58130147.png";